import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import Loading from "~/components/Loading";
import { useProjectAppsFeature } from "~/hooks/useProjectAppsFeature";
import { ROUTE_404 } from "~/router/constants";

/**
 * Flag gate for a published app's page, so a direct link outside the rollout
 * 404s like any unknown page. Waits for Flipt rather than redirecting on its
 * initial `false`.
 */
export const ProjectAppsFeatureRoute = ({ children }: { children: ReactNode }) => {
  const { enabled, isLoading } = useProjectAppsFeature();

  if (isLoading) {
    return <Loading />;
  }
  if (!enabled) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <>{children}</>;
};
